import {
  Box,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import { GetDeviceHistory } from "../Api"; // adjust as needed
import RefreshIcon from "@mui/icons-material/Refresh";
import Spinner from "../Spinner";

interface Props {
  handleCopyText: (text: string) => void;
  deviceID: string;
  refreshHistory: boolean;
}

// interface KV {
//   Key: string;
//   Value: any;
// }

interface HistoryEntry {
  id: string;
  deviceId: string;
  request: string[];
  response: string[];
  timestamp: string;
}

// Converts array of {Key, Value} into object
const flattenKVArray = (arr: string[]): any => {
  const obj: Record<string, any> = {};
  // arr.forEach(({ Key, Value }) => {
  //   if (Array.isArray(Value) && Value.every((v) => v.Key && v.Value)) {
  //     obj[Key] = flattenKVArray(Value); // nested array
  //   } else {
  //     obj[Key] = Value;
  //   }
  // });
  return obj;
};

function PreviewLogs(props: Props) {
  const { handleCopyText, deviceID, refreshHistory } = props;
  const [history, setHistory] = useState<HistoryEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory();
  }, [refreshHistory]);

  const fetchHistory = async () => {
    setLoading(true);
    const result = await GetDeviceHistory(deviceID);
    if (Array.isArray(result)) {
      setHistory(result);
    } else {
      console.error("Invalid response:", result);
      setHistory([]);
    }
    setLoading(false);
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography variant="h6" fontWeight="bold">
          Response
        </Typography>
        <IconButton size="small" onClick={fetchHistory}>
          <RefreshIcon />
        </IconButton>
      </Box>

      {loading ? (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          {loading && <Spinner running={loading} />}
        </Box>
      ) : history.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No data available.
        </Typography>
      ) : (
        <List disablePadding>
          {history.map((entry, index) => {
            const formattedRequest = entry.request;
            const formattedResponse = entry.response;
            const displayTime = new Date(entry.timestamp).toLocaleString();

            return (
              <ListItem
                key={entry.id || index}
                disablePadding
                sx={{
                  mb: 1,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  overflow: "hidden",
                  backgroundColor: "#fafafa",
                }}
              >
                <Accordion sx={{ width: "100%" }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight="bold" fontSize="0.9rem">
                      {displayTime}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ backgroundColor: "#fdfdfd", pt: 1 }}>
                    {/* Request */}
                    <Typography
                      variant="subtitle2"
                      fontWeight="bold"
                      gutterBottom
                    >
                      Request
                    </Typography>
                    <Box
                      component="pre"
                      sx={{
                        whiteSpace: "pre-wrap",
                        wordWrap: "break-word",
                        fontFamily: "monospace",
                        fontSize: "0.8rem",
                        backgroundColor: "#f3f3f3",
                        borderRadius: 1,
                        p: 1,
                      }}
                    >
                      {JSON.stringify(formattedRequest, null, 2)}
                    </Box>
                    <Box textAlign="right" mt={1} mb={2}>
                      <Button
                        size="small"
                        onClick={() =>
                          handleCopyText(
                            JSON.stringify(formattedRequest, null, 2)
                          )
                        }
                      >
                        Copy Request
                      </Button>
                    </Box>

                    {/* Response */}
                    <Typography
                      variant="subtitle2"
                      fontWeight="bold"
                      gutterBottom
                    >
                      Response
                    </Typography>
                    <Box
                      component="pre"
                      sx={{
                        whiteSpace: "pre-wrap",
                        wordWrap: "break-word",
                        fontFamily: "monospace",
                        fontSize: "0.8rem",
                        backgroundColor: "#f3f3f3",
                        borderRadius: 1,
                        p: 1,
                      }}
                    >
                      {JSON.stringify(formattedResponse, null, 2)}
                    </Box>
                    <Box textAlign="right" mt={1}>
                      <Button
                        size="small"
                        onClick={() =>
                          handleCopyText(
                            JSON.stringify(formattedResponse, null, 2)
                          )
                        }
                      >
                        Copy Response
                      </Button>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </ListItem>
            );
          })}
        </List>
      )}
    </>
  );
}

export default PreviewLogs;
